import { createContext, useContext } from 'react';

import { UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

type JourneyEditContextType = {
  isEditingTitle: boolean;
  publishMutation: UseMutationResult<AxiosResponse<any>, unknown, void, unknown>;
};

export const JourneyEditContext = createContext<JourneyEditContextType | undefined>(undefined);

export function useJourneyEditContext(): JourneyEditContextType {
  const ctx = useContext(JourneyEditContext);
  if (!ctx) {
    throw new Error('Missing JourneyEditContext');
  }

  return ctx;
}
